import { render, staticRenderFns } from "./DfrReportView.vue?vue&type=template&id=04ce1ab1&scoped=true"
import script from "./DfrReportView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DfrReportView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DfrReportView.vue?vue&type=style&index=0&id=04ce1ab1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ce1ab1",
  null
  
)

export default component.exports